import { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import type { DTOInviteFromSwipeAzarCard } from 'src/apis/dto/DTOInviteFromSwipeAzar';
import { ModalContent as ModalContentBase } from 'src/components/ModalLayout';
import InviteUserCard from './InviteUserCard';
interface Props {
  users: DTOInviteFromSwipeAzarCard[];
  selectedIds: Set<string>;
  onToggleSelect: (cardId: string) => void;
  onRemoveUser: (cardId: string) => void;
}
const List = styled.div`
  display: flex;
  flex-direction: column;
`;
const ModalContent = styled(ModalContentBase)`
  padding: 12px 0;
`;
export default function InviteUserList({
  users,
  selectedIds,
  onToggleSelect,
  onRemoveUser
}: Props) {
  const listRef = useRef<HTMLDivElement>(null);
  const showExtraButton = selectedIds.size > 0 && selectedIds.size < users.length;
  const prevShowExtraButtonRef = useRef(false);
  useEffect(() => {
    if (showExtraButton && !prevShowExtraButtonRef.current) {
      requestAnimationFrame(() => {
        const listEl = listRef.current;
        if (!listEl) return;
        const lastCheckedIndex = [...selectedIds].reduce((lastIdx, id) => {
          const idx = users.findIndex(u => u.cardId === id);
          return idx > lastIdx ? idx : lastIdx;
        }, -1);
        const lastCheckedCard = listEl.children[lastCheckedIndex] as HTMLElement | undefined;
        lastCheckedCard?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      });
    }
    prevShowExtraButtonRef.current = showExtraButton;
  }, [showExtraButton, selectedIds, users]);
  return <ModalContent data-sentry-element="ModalContent" data-sentry-component="InviteUserList" data-sentry-source-file="InviteUserList.tsx">
      <List ref={listRef} data-sentry-element="List" data-sentry-source-file="InviteUserList.tsx">
        {users.map(user => <InviteUserCard key={user.cardId} user={user} isSelected={selectedIds.has(user.cardId)} onToggleSelect={onToggleSelect} onRemove={onRemoveUser} />)}
      </List>
    </ModalContent>;
}